﻿export const DEFAULT_PAGE_TITLE = 'Plastics marketplace - Atomler';
export const DEFAULT_META_DESCRIPTION =
  'At Atomler you will find any used industrial plastic waste you need. Discounted plastic materials such as PP, PE, PA6, PET, ABS and more.';
export const SERVICE_FEE_PERCENTAGE = 3;
